import type { FC } from 'react';
import { memo } from 'react';
import Logo from '@components/Logo';

interface HeaderLogoProps {
  isShowHeaderShadow?: boolean;
}

const HeaderLogo: FC<HeaderLogoProps> = ({ isShowHeaderShadow = false }) => (
  <Logo
    isSmall={isShowHeaderShadow}
    className={`header-logo${isShowHeaderShadow ? ' header-logo--small' : ''}`}
  />
);

export default memo(HeaderLogo);
